import { render } from "./SelectInputFilter.vue?vue&type=template&id=42845a30"
import script from "./SelectInputFilter.vue?vue&type=script&lang=js"
export * from "./SelectInputFilter.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/helpdesk.moov-africa.bj/releases/81254874/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__